import React from 'react'
import {connect} from 'react-redux'
import styles from './TRouteMapBlock.scss'
import {Block} from '../Block'
import {BlockCaption} from '../BlockCaption'
import {MetricsPicker} from '../MapBlock/MetricsPicker'
import {TRouteMapViewer} from 'features/ride_reports/ShowPage/ReportViewer/TRouteMapViewer'
import {tripActions} from 'data/resources/trips'
import {routeActions} from 'data/resources/routes'
import {Popover} from 'common/Popover'
import {RadioGroup} from 'common/styleguide/RadioGroup'
import {tileServices} from 'lib/tileServices'
import {OrderedMap, Set} from 'immutable'
import _ from 'lodash'

export class _TRouteMapBlock extends React.PureComponent {
  static defaultMetrics = ['distance', 'eleGain', 'movingTime', 'avgSpeed', 'maxSpeed']

  constructor (props) {
    super(props)

    this.state = {
      fetchPending: false,
      overlay: tileServices.rwgps,
      initialViewport: null,
      hoveredFeature: null,
      selectedFeature: null,
      zoom: 1,
      showMetricsPicker: false,
      metricsEnabled: Set(['ele'])
    }
  }

  onTRouteTypeChange = (objectType) => {
    this.props.blockProps.onChange({objectType})
  }

  onTRouteIdChange = (e) => {
    const objectId = e.target.value

    this.props.blockProps.onChange({objectId})
  }

  toggleGraph = () => {
    const sampleGraph = !this.props.block.getData().get('sampleGraph', true)
    this.props.blockProps.onChange({sampleGraph})
  }

  toggleBalloon = () => {
    const showPopover = !this.props.block.getData().get('showPopover', false)
    this.props.blockProps.onChange({showPopover})
  }

  toggleMetrics = () => {
    const showMetrics = !this.props.block.getData().get('showMetrics', false)
    this.props.blockProps.onChange({showMetrics})
  }

  toggleMetricsPicker = () => {
    const showMetricsPicker = !this.state.showMetricsPicker
    this.setState({showMetricsPicker})
  }

  updateMetrics = (metricsToShow) => {
    const {onChange} = this.props.blockProps
    onChange({metricsToShow})
    this.setState({showMetricsPicker: false})
  }

  render () {
    const {block, blockProps} = this.props
    const {showMetricsPicker} = this.state
    const {isSelected} = blockProps
    const data = block.getData()
    const objectId = data.get('objectId')
    const objectType = data.get('objectType')
    const sampleGraph = data.get('sampleGraph', true)
    const showPopover = data.get('showPopover', true)
    const showMetrics = data.get('showMetrics', false)
    const metricsToShow = data.get('metricsToShow', objectType === 'route'
      ? _.pull(_TRouteMapBlock.defaultMetrics, 'avgSpeed', 'maxSpeed', 'movingTime')
      : _TRouteMapBlock.defaultMetrics)

    if (!(objectId && objectType)) {
      return (
        <Block block={block} blockProps={blockProps}>
          <form>
            <label>troute type:</label>
            <RadioGroup
              horizontal
              selected={objectType}
              options={OrderedMap({trip: 'trip', route: 'route'})}
              onChange={this.onTRouteTypeChange} />
            <label>troute id:</label>
            <input onChange={this.onTRouteIdChange} />
          </form>
        </Block>
      )
    }

    return (
      <Block block={block} blockProps={blockProps}>
        <div className={styles.TRouteMapBlock}>
          {isSelected && <Popover onMouseDown={e => e.preventDefault()}>
            <li onClick={this.toggleGraph}>
              {sampleGraph
                ? 'hide elevation'
                : 'show elevation'}
            </li>
            <li onClick={this.toggleBalloon}>
              {showPopover
                ? 'hide popover'
                : 'show popover'}
            </li>
            <li onClick={this.toggleMetrics}>
              {showMetrics
                ? 'hide metrics'
                : 'show metrics'}
            </li>
            {showMetrics && <li onClick={this.toggleMetricsPicker}>customize metrics</li>}
          </Popover>}
          <TRouteMapViewer
            ref={r => { this._map = r }}
            block={block}
            blockProps={blockProps}
            sampleGraph={sampleGraph}
            showPopover={showPopover}
            showMetrics={showMetrics} />
          {showMetricsPicker && <MetricsPicker
            objectType={objectType}
            onClose={this.toggleMetricsPicker}
            selected={metricsToShow}
            onConfirm={this.updateMetrics} />}
        </div>
        <BlockCaption block={this.props.block} blockProps={this.props.blockProps} />
      </Block>
    )
  }
}

const mapDispatchToProps = ({
  loadTrip: tripActions.read,
  loadRoute: routeActions.read
})

export const TRouteMapBlock = connect(
  null,
  mapDispatchToProps
)(_TRouteMapBlock)
